/** @format */

/* eslint require-await: "warn" -- Legacy code: do not use as an example. */
import { TFunction } from 'i18next';
import { SingletonRouter } from 'next/router';

import { BASKET_MPBX_BRIDGE_FEATURE_FLAG } from '@toucan/common/services/feature-flags/constants';
import { FeatureFlag } from '@toucan/common/services/feature-flags/types';

import {
    BasketTransactionSummary,
    MixedTransaction,
} from '@toucan/client/global/transaction';

import { BasketVariant } from '../config/constants';

/**
 * Redirect the user to the model page
 *
 * @param marketSlug the active market slug
 * @param modelSlug the model to link to
 * @param router the next page  router
 */
export async function findAnotherProduct(
    marketSlug: string,
    modelSlug: string,
    // eslint-disable-next-line id-length -- Legacy code: do not use as an example.
    t: TFunction,
    router: SingletonRouter
): Promise<boolean> {
    const productSlug = t('product', { ns: 'urls' });
    const pathname = `/model?slug=${modelSlug}`;
    const url = `/${marketSlug}/${productSlug}/${modelSlug}`;

    return router.push(
        {
            pathname,
        },
        url
    );
}

/**
 * Redirect the user to the checkout
 *
 * @param marketSlug the active market slug
 * @param isLoggedIn whether the user is logged in
 * @param t the translation function
 * @param router the next page  router
 */
export function navigateToCheckout(
    marketSlug: string,
    isLoggedIn: boolean,
    // eslint-disable-next-line id-length -- Legacy code: do not use as an example.
    t: TFunction,
    router: SingletonRouter
): Promise<boolean> {
    const pathname = isLoggedIn ? '/checkout' : '/checkout-login';
    const url = isLoggedIn
        ? `/${marketSlug}/s/${t('checkout', { ns: 'urls' })}`
        : `/${marketSlug}/s/${t('checkout', {
              ns: 'urls',
          })}/${t('login', { ns: 'urls' })}`;

    return router.push(
        {
            pathname,
        },
        url
    );
}

export function getBasketVariant(
    // eslint-disable-next-line @typescript-eslint/array-type -- Legacy code: do not use as an example.
    featureFlags: readonly FeatureFlag[]
): BasketVariant {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    const newBasket =
        featureFlags.find(
            (flag) => flag.name === BASKET_MPBX_BRIDGE_FEATURE_FLAG
        )?.isEnabled ?? false;

    return newBasket ? BasketVariant.NEW_BASKET : BasketVariant.OLD_BASKET;
}

export function hasBasketChanged(
    { itemsToBuy: originalItemsToBuy }: MixedTransaction,
    { itemsToBuy: latestItemsToBuy }: BasketTransactionSummary
) {
    if (originalItemsToBuy.length !== latestItemsToBuy.length) {
        return true;
    }

    return originalItemsToBuy.some((originalItem) => {
        const latestVersionOfItem = latestItemsToBuy.find(
            (latestItem) => latestItem.productId === originalItem.productId
        );

        return latestVersionOfItem?.value !== originalItem.value;
    });
}
